import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { BiMinus, BiPlus } from 'react-icons/bi';
import { MdWarning } from 'react-icons/md';
import { format } from 'date-fns';

import { status } from '../../../utils/utils';
import useWindowSize from '../../../hooks/useWindowSize';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

export default function QuestionRow({ question, styles, isAssign, isMember }) {
  const { width } = useWindowSize();
  const [questionIsOpen, setQuestionIsOpen] = useState(false);
  const contentRef = useRef(null);
  const history = useHistory();
  const handleNavigate = () => {
    if (isMember) return history.push(`/question-member/${question._id}`);
    const url = isAssign ? `/question-assign/${question._id}` : `/question/${question._id}`;
    return history.push(url);
  }
  if (width < 1024) {
    return <button className={styles.questionMobile}
      onClick={() => handleNavigate()}
    >
      <div className={styles.infos}>
        <p>
          <span>{question.code}</span>
          {" "}/{" "}
          <span className={styles.author}>
            {question?.author?.lastName && <>{question?.author?.firstName && question?.author?.firstName[0]?.toUpperCase()}{question?.author?.firstName && '.'}{question?.author?.lastName?.toUpperCase()}</>}
            {question?.author?.name && <>{question?.author?.name?.toUpperCase()}</>}
            {question?.addedBy?.profile?.lastName && <> (par {question?.addedBy?.profile?.firstName && question?.addedBy?.profile?.firstName[0]?.toUpperCase()}{question?.addedBy?.profile?.firstName && '.'}{question?.addedBy?.profile?.lastName?.toUpperCase()})</>}
          </span>
        </p>
        <p>
          <span style={{ color: status[question.status].color }}>{status[question.status].label}</span>
          {" "}/{" "}

          {question?.delay >= 7 && <span className="text-error">{question.delay} j</span>}
          {question?.delay < 7 && <span className="text-success">{question.delay} j</span>}
        </p>
      </div>
      <p>{question.title || question.code}</p>
    </button>
  }

  return (
    <div className="box">
      <div className={`${styles.row}`}>
        <div className={`${styles.col}`}>
          {question?.code && <p>{question?.code}</p>}
        </div>
        <div className={`${styles.col} ${styles.title}`}>
          {!isMember ?
            <Link to={isAssign ? `/question-assign/${question._id}` : `/question/${question._id}`} className="bold">
              <p>{question.title || question.code}</p>
            </Link>
            :
            <p className="bold">{question.title}</p>
          }
        </div>
        <div className={`${styles.col} ${styles.author}`}>
          <p>
            {question?.author?.lastName && <>{question?.author?.firstName && question?.author?.firstName[0]?.toUpperCase()}{question?.author?.firstName && '.'}{question?.author?.lastName?.toUpperCase()}</>}
            {question?.author?.name && <>{question?.author?.name?.toUpperCase()}</>}
            {question?.addedBy?.profile?.lastName && <><br/>(par {question?.addedBy?.profile?.firstName && question?.addedBy?.profile?.firstName[0]?.toUpperCase()}{question?.addedBy?.profile?.firstName && '.'}{question?.addedBy?.profile?.lastName?.toUpperCase()})</>}
          </p>
        </div>
        <div className={`${styles.col} ${styles.date}`}>
          <p>{question.date && format(new Date(question.date), 'dd/MM/yy')}</p>
        </div>
        <div className={`${styles.col} ${styles.date}`}>
          {question?.answer?.date && <p>{format(new Date(question?.answer.date), 'dd/MM/yy')}</p>}
        </div>
        <div className={`${styles.col}`}>
          {question?.assignTo?._id ? <p className="text-success">{question?.assignTo.profile.lastName.charAt(0).toUpperCase()}.{question?.assignTo.profile.firstName.charAt(0).toUpperCase()}</p> : <p className="text-error">NON</p>}
        </div>
        <div className={`${styles.col}`}>
          <p style={{ color: status[question.status].color }}>{status[question.status].label}</p>
        </div>
        <div className={`${styles.col} ${styles.delay}`}>
          {question?.delay >= 7 && <p className="text-error">{question.delay} jours <MdWarning size={18} /></p>}
          {question?.delay < 7 && <p className="text-success">{question.delay} jours </p>}
        </div>
        <div className={`${styles.toggle}`}>
          {!isMember &&
            <button
              onClick={() => setQuestionIsOpen(!questionIsOpen)}
            >
              {questionIsOpen ? <BiMinus size={32} /> : <BiPlus size={32} />}
            </button>
          }
        </div>
      </div>
      <div className={styles.panel} style={{ height: questionIsOpen && contentRef.current ? contentRef.current.clientHeight : 0 }}>
        <div ref={contentRef} className={styles.question}>

          <div className={styles.col}>
            <div className={styles.text}>
              <p><span className="bold">Question </span>
                {question?.author?.lastName && <span>{question?.author?.firstName} {question?.author?.lastName?.toUpperCase()}</span>}
                {question?.author?.name && <span>{question?.author?.name?.toUpperCase()}</span>}
              </p>
              <p>{question?.question}</p>
            </div>
          </div>

          <div className={styles.col}>
            <div className={styles.text}>
              {question.assignTo &&
                <p>
                  <span className="bold">Réponse de </span>
                  {question.answer?.author?._id !== question.assignTo._id ?
                    <span>{question.answer?.author?.profile?.firstName} {question.answer?.author?.profile?.lastName} <br />(assignée à {question.assignTo?.profile?.firstName} {question.assignTo?.profile?.lastName})</span>
                    :
                    <span>{question.assignTo?.profile?.firstName} {question.assignTo?.profile?.lastName}</span>
                  }
                  {question.answer?.date && <span><br />le {format(new Date(question.answer.date), 'dd/MM/yyyy')}</span>}
                </p>
              }
              {question?.answer?.answer &&
                <div dangerouslySetInnerHTML={{ __html: question?.answer?.answer }}></div>
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
